import { Injectable } from '@angular/core';
import { HttpService, PagedList } from '../core/index';
import { GetSystemicCaseListParams, SystemicCaseBasicInfoModel, SystemicCaseListItemModel } from './models/systemic-cases.models';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { getFileNameFromResponseContentDisposition, saveFile } from '../shared';

@Injectable()
export class SystemicCasesRepositoryService {
   static injectName = 'systemicCasesRepository';
   private baseUrl = 'api/systemiccases';

   constructor(private http: HttpService) { }

   getBasicInfo(systemicCaseId: string) {
      const url = `${this.baseUrl}/${systemicCaseId}/basicinfo`;
      return this.http.get<SystemicCaseBasicInfoModel>(url);
   }

   getActiveCaseCount(userIds: string[], roles: string[]) {
      const url = `${this.baseUrl}/activeCaseCount`;
      return this.http.get<number>(url, { params: { userIds, roles } });
   }

   getSystemicCaseList(data: GetSystemicCaseListParams): Observable<PagedList<SystemicCaseListItemModel>> {
      const url = `${this.baseUrl}/list`;
      return this.http.post<PagedList<SystemicCaseListItemModel>>(url, data);
   }

   getSystemicCaseListDownload(data: GetSystemicCaseListParams) {
      const url = `${this.baseUrl}/list/csv`;
      return this.http.post<HttpResponse<Blob>>(url, data, { responseType: 'blob', observe: 'response' }).pipe(
         tap(res => {
            const fileName = getFileNameFromResponseContentDisposition(res);
            saveFile(res.body, fileName);
         })
      );
   }

   deleteSystemicCase(id: string) {
      return this.http.delete(`${this.baseUrl}/${id}`);
   }
}
